import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Toast } from 'react-weui';
import PropTypes from 'prop-types';

import Http from 'services/http2';
import User from 'services/user2';
import * as MobileActions from 'actions/index.ts';
import ReactEcharts from 'echarts-for-react';

import Swiper from 'swiper/swiper-bundle.min.js';
import 'swiper/swiper.min.css';
import '../annualSummary.css';

const Config = {
  purchase: {
    items: [
      { label: '采购价格下降率', code: 'purPriceDownRate', value: 0 },
      { label: '采购良品率', code: 'purQualifiedRate', value: 0 },
      { label: '供应商答交率', code: 'poAnswerRate', value: 0 },
      { label: '订单准时答交率', code: 'poAnswerOntimeRate', value: 0 },
      { label: '供应商对账率', code: 'vstatementRate', value: 0 },
    ],
  },
  sale: {
    items: [
      { label: '准时答交率', code: 'poAnswerOntimeRate', value: 0 },
      { label: '准时交货率', code: 'deliveryOntimeRate', value: 0 },
      { label: '批次合格率', code: 'batchQualifiedRate', value: 0 },
      { label: '交货良品率', code: 'deliveryQualifiedRate', value: 0 },
    ],
  },
};

/*
dev
http://open.weixin.qq.com/connect/oauth2/authorize?appid=wxf3cf604fbe16e419&redirect_uri=https%3A%2F%2Fdev.xiekeyun.com%2Fmp%2Fannual-summary&response_type=code&scope=snsapi_base&state=123#wechat_redirect
腾讯短链接： https://mmbizurl.cn/s/ApTPHY7ig

prod
http://open.weixin.qq.com/connect/oauth2/authorize?appid=wx69332f4727b14d05&redirect_uri=https%3A%2F%2Fconsole.xiekeyun.com%2Fmp%2Fannual-summary&response_type=code&scope=snsapi_base&state=123#wechat_redirect
腾讯短链接： https://mmbizurl.cn/s/ApTPHY7ig
*/

//https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxf3cf604fbe16e419&redirect_uri=http://mp.xiekeyun.com/mp/test&response_type=code&scope=snsapi_base&state=123#wechat_redirect

class annualSummary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: window.location.search,
      src: '',
      chartOpt: {},
      imageDataUrl: '',
      error: null,
      complete: false,
    };
    this.type = 'purchase';
    this.ctx = null;
    this.canvas = null;
    this.clientWidth = 0;
    this.swiper = null;
    this.detail = {
      login: null,
      purchase: null,
      sales: null,
    };
    this.renderData = {
      rate01: {},
      rate02: {},
      rate03: {},
      registerTimeY: '',
      registerTimeM: '',
      registerTimeD: '',
      registerDays: 0,
      earliestTimeArr: [],
      latestTimeArr: [],
      tagName: '供应链战狼',
      remark: '今天搬砖不狠，明天地位不稳，当之无愧的打工人楷模是你没跑了',
    };
    this.activeIndex = 0;
  }

  componentDidMount() {
    var root = document.getElementById('root');
    root.querySelector('.container').style.height = root.clientHeight + 'px';
    this.clientWidth = root.clientWidth;
    this.init();
  }

  init() {
    User.init(this.companyCode).then(response => {
      if (response.success) {
        this.getDetail();
        this.setState({ inited: true });
        // Init Swiper
        this.swiper = new Swiper('.swiper-container', {
          direction: 'vertical',
          on: {
            // slideChangeTransitionEnd: (swp) => {
            //   this.activeIndex = swp.activeIndex;
            // },
            reachEnd: swp => {
              //最后一屏，合成图片
              if (swp.activeIndex === 0) {
                return;
              }
              const canvas = document.querySelector('canvas');
              let str = canvas.toDataURL();
              this.setState({ src: str });
              this.drawCanvas();
            },
          },
        });
      } else {
        //非平台用户，报告页显示相应提示
        this.setState({
          error: {
            type: 'warn',
            title: response.errorMsg,
          },
        });
      }
    });
  }

  async getDetail() {
    let error = null;
    let postbody = {
      apiPath: '/userReport/year',
    };
    await Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success && response.data) {
        let data = response.data;
        if (data.login) {
          if (data.login.registerTime) {
            var d = new Date(data.login.registerTime);
            this.renderData.registerTimeY = d.getFullYear();
            this.renderData.registerTimeM = d.getMonth() + 1;
            this.renderData.registerTimeD = d.getDate();
          }
          ['earliestTime', 'latestTime'].forEach(key => {
            if (data.login[key]) {
              let arr = data.login[key].split(':');
              if (Array.isArray(arr)) {
                arr.forEach(val => {
                  val = val || 0;
                  val = parseInt(val, 10);
                  this.renderData[key + 'Arr'].push(val);
                });
              }
            }
          });
          this.renderData = Object.assign(this.renderData, data.login);
        }
        // data.purchase不为null，即是采购方
        if (data.purchase) {
          this.type = 'purchase';
          Config[this.type].items.forEach(item => {
            item.value = data.purchase[item.code] || 0;
            item.value = parseFloat((item.value * 100).toFixed(2), 10);
            item.value = item.value > 100 ? 100 : item.value;
          });
          //取分数前三项数据
          Config[this.type].items.sort((a, b) => b.value - a.value);
          Config[this.type].items.forEach((item, i) => {
            let idx = i + 1;
            this.renderData['rate0' + idx] = item;
          });
          this.renderData = Object.assign(this.renderData, data.purchase);
        } else if (data.sales) {
          this.type = 'sale';
          Config[this.type].items.forEach(item => {
            item.value = data.sales[item.code] || 0;
            item.value = parseFloat((item.value * 100).toFixed(2), 10);
            item.value = item.value > 100 ? 100 : item.value;
          });
          //取分数前三项数据
          Config[this.type].items.sort((a, b) => b.value - a.value);
          Config[this.type].items.forEach((item, i) => {
            let idx = i + 1;
            this.renderData['rate0' + idx] = item;
          });
          this.renderData = Object.assign(this.renderData, data.sales);
        }
        if (this.renderData.poCount) {
          this.renderData.saveTime = this.renderData.poCount * 5; //节省纸张
          this.renderData.emissions = this.renderData.poCount * 2 * 15.281; //碳排放量
        }
        if (!this.renderData.poCount || !data.login) {
          //没有对应数据
          error = '没有数据';
        }
        this.detail = data;
        if (error === null) {
          this.renderRadar();
        }
      } else {
        //没有对应数据
        error = '没有数据';
      }
      this.setState({ error: error });
      this.setState({ complete: true });
      if (this.state.error !== null) {
        this.swiper = new Swiper('.swiper-container', {
          direction: 'vertical',
        });
      }
      //播放音频
      var music = document.getElementById('music');
      if (music !== null) {
        music.play();
      }
    });
  }

  //渲染雷达图
  renderRadar() {
    let indicator = [];
    let seriesData = [];
    Config[this.type].items.forEach((item, i) => {
      //前三项数据
      if (i < 3) {
        indicator.push({
          name: item.label + '\n' + item.value + '%',
          max: 100,
        });
        seriesData[i] = item.value;
      }
    });
    this.setState({ chartOpt: this.getRadarOpt(indicator, seriesData) });
  }

  getRadarOpt(radarIndicator = [], seriesData = [], seriesName = '') {
    return {
      legend: {},
      tooltip: {
        show: false,
      },
      color: ['rgb(119, 168, 250)'],
      radar: {
        radius: '28%',
        name: {
          rich: {
            a: {
              color: '#454545',
              lineHeight: 14,
              align: 'center',
              fontSize: 10,
            },
          },
          formatter: (a, b) => {
            return `{a|${a}}`;
          },
        },
        indicator: radarIndicator,
      },
      series: [
        {
          type: 'radar',
          name: seriesName,
          itemStyle: { normal: { areaStyle: { type: 'default' } } },
          data: [{ value: seriesData }],
        },
      ],
    };
  }

  //绘图
  drawCanvas() {
    //var self = this;
    // var imgsrcArray = [
    //   '/assets/img/swiper/annual-report-06.png?v12522',
    //   this.state.src,
    // ];
    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext('2d');
    var ratio = this.getPixelRatio(ctx);
    canvas.width = this.clientWidth * ratio;
    canvas.height = (this.clientWidth / 0.4618) * ratio; //原始图片宽高比例
    //var imglen = imgsrcArray.length;
    // var drawimg = (function f(n) {
    //   if (n < imglen) {
    //     var img = new Image();
    //     img.crossOrigin = 'Anonymous'; //解决跨域问题
    //     img.onload = function () {
    //       if (n === 0) {
    //         ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
    //       } else {
    //         ctx.drawImage(img, 0, canvas.height * 0.46, canvas.width, 0.75 * canvas.width);
    //       }
    //       f(n + 1);
    //     };
    //     img.src = imgsrcArray[n];
    //   } else {
    //     let remark = '解读：' + self.renderData.remark;
    //     //文本1
    //     ctx.font = 'bold ' + (90 * ratio) / 3 + 'px sans-serif';
    //     ctx.fillStyle = '#f77a02';
    //     ctx.textAlign = 'center';
    //     ctx.fillText(self.renderData.tagName.replace('供应链', ''), canvas.width / 2, canvas.height * 0.335);
    //     //文本2
    //     ctx.font = (32 * ratio) / 3 + 'px sans-serif';
    //     ctx.fillStyle = '#454545';
    //     ctx.textAlign = 'center';
    //     self.drawText(ctx, remark, canvas.width / 2, canvas.height * 0.35, canvas.width * 0.65, ratio);
    //     //文本3
    //     ctx.font = (36 * ratio) / 3 + 'px sans-serif';
    //     ctx.fillStyle = '#454545';
    //     ctx.textAlign = 'left';
    //     ctx.fillText('订单数', 70 * ratio, canvas.height * 0.485);
    //     ctx.fillText('节省时间', 155 * ratio, canvas.height * 0.485);
    //     ctx.fillText('累计减排', 245 * ratio, canvas.height * 0.485);
    //     //文本4
    //     ctx.font = (36 * ratio) / 3 + 'px sans-serif';
    //     ctx.fillStyle = '#2c79fc';
    //     ctx.fillText((self.renderData.poCount || '') + '个', 70 * ratio, canvas.height * 0.505);
    //     ctx.fillText((self.renderData.saveTime || '') + '分钟', 155 * ratio, canvas.height * 0.505);
    //     ctx.fillText((self.renderData.emissions || '') + 'g', 245 * ratio, canvas.height * 0.505);

    //     let imageDataUrl = canvas.toDataURL('image/jpeg');
    //     imageDataUrl = imageDataUrl.replace('data:image/jpeg;base64,', '');
    //     self.setState({ imageDataUrl: imageDataUrl });
    //   }
    // })(0);
  }

  //像素比例，解决高清屏生成图片模糊
  getPixelRatio(context) {
    var backingStore =
      context.backingStorePixelRatio ||
      context.webkitBackingStorePixelRatio ||
      context.mozBackingStorePixelRatio ||
      context.msBackingStorePixelRatio ||
      context.oBackingStorePixelRatio ||
      context.backingStorePixelRatio ||
      1;
    return (window.devicePixelRatio || 1) / backingStore;
  }

  //文字换行
  drawText(context, t, x, y, w, ratio) {
    var chr = t.split('');
    var temp = '';
    var row = [];

    context.textBaseline = 'middle';
    for (var a = 0; a < chr.length; a++) {
      if (context.measureText(temp).width < w) {
        //todo
      } else {
        row.push(temp);
        temp = '';
      }
      temp += chr[a];
    }
    row.push(temp);
    for (var b = 0; b < row.length; b++) {
      context.fillText(row[b], x, y + (b + 1) * ((45 * ratio) / 3));
    }
  }

  //音频控制
  musicControl() {
    var audio = document.getElementById('music');
    var control = document.getElementById('music-control');
    if (audio !== null) {
      if (audio.paused) {
        audio.play();
        control.className = '';
      } else {
        audio.pause();
        control.className = 'paused';
      }
    }
  }

  componentWillUnmount() {}

  render() {
    const { imageDataUrl } = this.state;
    if (this.state.error !== null && this.state.error.type) {
      return (
        <Toast icon="warn" show={true}>
          {this.state.error.title}
        </Toast>
      );
    }
    if (this.state.error !== null) {
      return (
        <div className="swiper-container swiper-no-swiping">
          <div className="swiper-wrapper">
            <div className="swiper-slide slide-01">
              <div className="swiper-slide-in animate__animated">
                <img src="/assets/img/swiper/xsg.png" alt="" />
              </div>
              <div className="btn animate__animated animate__delay-1s">
                <img
                  onClick={() => this.swiper.slideNext()}
                  src="/assets/img/swiper/btn.png"
                  alt=""
                />
              </div>
            </div>
            <div className="swiper-slide slide-02">
              <img
                className="animate-item item-02 animate__animated animate__delay-2s"
                src="/assets/img/swiper/annual-report-02-2.png"
                alt=""
              />
              <div className="swiper-slide-in animate__animated animate__delay-1s">
                <p>亲爱的朋友</p>
                <p>也许是2020太匆忙</p>
                <p>我们没来得及深入协作</p>
                <p>数据不足，无法生成你的专属报告</p>
                <p></p>
                <p className="big">
                  <b>2021年</b>
                </p>
                <p className="big">期待与你高效协作</p>
                <p className="big">让你的每笔采购更高效受控</p>
              </div>
            </div>
          </div>
          <audio
            src="/assets/img/swiper/a.aac"
            controls="controls"
            loop="loop"
            id="music"
            hidden
          ></audio>
          <img
            onClick={() => this.musicControl()}
            src="/assets/img/swiper/music_fill.png"
            id="music-control"
            alt=""
          />
        </div>
      );
    }
    return (
      <div className="swiper-container">
        <div className="swiper-wrapper">
          <div className="swiper-slide slide-01">
            <div className="swiper-slide-in animate__animated">
              <img src="/assets/img/swiper/xsg.png" alt="" />
            </div>
            <div className="btn animate__animated animate__delay-1s">
              <img
                onClick={() => this.swiper.slideNext()}
                src="/assets/img/swiper/btn.png"
                alt=""
              />
            </div>
          </div>
          <div className="swiper-slide slide-02">
            <img
              className="animate-item item-02 animate__animated animate__delay-2s"
              src="/assets/img/swiper/annual-report-02-2.png"
              alt=""
            />
            <div className="swiper-slide-in animate__animated animate__delay-1s">
              <p>
                <b>{this.renderData.registerTimeY}</b> 年{' '}
                <b>{this.renderData.registerTimeM}</b> 月{' '}
                <b>{this.renderData.registerTimeD}</b> 日
              </p>
              <p>我们第一次相遇</p>
              <p>共同开启了供应链在线协同之旅</p>
              <p></p>
              <p>
                在2020与你相处的 <b>{this.renderData.loginCount}</b> 个日夜里
              </p>
              <p>我们默默记着你的每分努力</p>
            </div>
            <div className="btm">
              <p>上滑查看我的年度报告</p>
              <span>》</span>
            </div>
            <div className="qrcode">
              <img src="/assets/img/swiper/qrcode.png" alt="" />
              <p>扫码生成账单</p>
            </div>
          </div>
          <div className="swiper-slide slide-03">
            <img
              className="animate-item item-03 animate__animated animate__delay-2s"
              src="/assets/img/swiper/annual-report-03-2.png"
              alt=""
            />
            <div className="swiper-slide-in animate__animated animate__delay-1s">
              <p>
                早至 <b>{this.renderData.earliestTimeArr[0]}</b> 时{' '}
                <b>{this.renderData.earliestTimeArr[1]}</b> 分，晚至{' '}
                <b>{this.renderData.latestTimeArr[0]}</b> 时{' '}
                <b>{this.renderData.latestTimeArr[1]}</b> 分
              </p>
              <p></p>
              <p>不论朝夕</p>
              <p>我们都会默默陪伴你一起努力</p>
            </div>
            <div className="btm">
              <p>上滑查看我的年度报告</p>
              <span>》</span>
            </div>
            <div className="qrcode">
              <img src="/assets/img/swiper/qrcode.png" alt="" />
              <p>扫码生成账单</p>
            </div>
          </div>
          <div className="swiper-slide slide-04">
            <img
              className="animate-item item-04 animate__animated animate__delay-2s"
              src="/assets/img/swiper/annual-report-04-2.png"
              alt=""
            />
            <div className="swiper-slide-in animate__animated animate__delay-1s">
              <p>
                这一年，你累计处理了 <b>{this.renderData.poCount || ''}</b>{' '}
                个订单流程
              </p>
              <p>保障了公司供应链业务的正常化</p>
              <p></p>
              <p>通过数字化的协同</p>
              <p>
                节省了 <b>{this.renderData.saveTime || ''}分钟</b>
              </p>
              <p></p>
              <p>如果不再使用纸张</p>
              <p>
                可以减少 <b>{this.renderData.emissions || ''}g</b> 的碳排放
              </p>
            </div>
            <div className="btm">
              <p>上滑查看我的年度报告</p>
              <span>》</span>
            </div>
            <div className="qrcode">
              <img src="/assets/img/swiper/qrcode.png" alt="" />
              <p>扫码生成账单</p>
            </div>
          </div>
          <div className="swiper-slide slide-05">
            <img
              className="animate-item item-05 animate__animated animate__delay-2s"
              src="/assets/img/swiper/annual-report-05-2.png"
              alt=""
            />
            <div className="swiper-slide-in animate__animated animate__delay-1s">
              <p>2020的你，战绩满满</p>
              {this.renderData.potVendorCount ? (
                <p>
                  共开发了 <b>{this.renderData.potVendorCount}</b> 家新的供应商
                </p>
              ) : (
                ''
              )}
              {this.renderData.purPriceDownRate ? (
                <p>
                  采购价格下降了 <b>{this.renderData.purPriceDownRate}%</b>
                </p>
              ) : (
                ''
              )}
              {this.renderData.purPriceDownRate ? (
                <p>真的帮公司省了好多钱哦</p>
              ) : (
                ''
              )}
              {this.renderData.quoteOrderCount ? (
                <p>
                  共参与了 <b>{this.renderData.quoteOrderCount}</b> 单报价
                </p>
              ) : (
                ''
              )}
              {this.renderData.statementOrderCount ? (
                <p>
                  <b>{this.renderData.statementOrderCount}</b> 张对账单
                </p>
              ) : (
                ''
              )}
              <p></p>
              <p>你的职业战斗力超乎常人</p>
              {this.renderData['rate01'].value > 0 ? (
                <p>
                  {this.renderData['rate01'].label}：
                  <b>{this.renderData['rate01'].value}%</b>
                </p>
              ) : (
                ''
              )}
              {this.renderData['rate02'].value > 0 ? (
                <p>
                  {this.renderData['rate02'].label}：
                  <b>{this.renderData['rate02'].value}%</b>
                </p>
              ) : (
                ''
              )}
              {this.renderData['rate03'].value > 0 ? (
                <p>
                  {this.renderData['rate03'].label}：
                  <b>{this.renderData['rate03'].value}%</b>
                </p>
              ) : (
                ''
              )}
            </div>
            <div className="btm">
              <p>上滑查看我的年度报告</p>
              <span>》</span>
            </div>
            <div className="qrcode">
              <img src="/assets/img/swiper/qrcode.png" alt="" />
              <p>扫码生成账单</p>
            </div>
          </div>
          <div className="swiper-slide slide-06">
            <img
              src={'data:image/jpeg;base64,' + imageDataUrl}
              alt="账单图片"
            />
            <p>长按保存图片至相册</p>
          </div>
        </div>
        <audio
          src="/assets/img/swiper/a.aac"
          controls="controls"
          loop="loop"
          id="music"
          hidden
        ></audio>
        <img
          onClick={() => this.musicControl()}
          src="/assets/img/swiper/music_fill.png"
          id="music-control"
          alt=""
        />
        <ReactEcharts
          option={this.state.chartOpt}
          notMerge={true}
          lazyUpdate={true}
        />
      </div>
    );
  }
}

annualSummary.propTypes = {
  data: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
};

const mapStateToProps = state => {
  return {
    data: state.login,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(annualSummary);
